module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-6.2609c723.jpg";